<div class="confirm-modal ig-modal edit-manually-place-images-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <h3 class="title">EDIT PLACE IMAGES</h3>

    <div class="edit-wrap">
        <div *ngIf="!isPlaceInfoLoaded" class="flex justify-center" style="margin:32px 0">
            <div class="flex flex-col items-center gap-2">
                <ig-spinner></ig-spinner>
                Loading images...
            </div>
        </div>

        <div *ngIf="isPlaceInfoLoaded" class="relative">
            <h4 style="color:#67757c;margin:0 0 12px 0">Each place listing can display up
                to {{ totalImageCountThatSysAdminSet }}
                images, in a slideshow, with the first picture acting as the cover photo. The cover may be a manual
                upload of your choice. Drag-and-drop images in place to re-order how
                they appear.
            </h4>
            <h3 class="image-title">Images Displayed on Website Listing</h3>
            <div class="flex gap-4" style="height:9vmin;width:calc(100% - 10px);position: relative">
                <div *ngFor="let image of publishedImages;let i=index" class="place-img-wrap relative" draggable
                    [dragScope]="'items'" [dragData]="image" (onDrag)="startDrag($event, 'allowed')" droppable
                    [dropScope]="'items'" (onDragOver)="dragEnter($event)" (onDrop)="onItemDrop($event, 'allowed', i)">
                    <img [src]="getImage(image)" alt="img">
                    <div class="absolute flex justify-center items-center gap-4"
                        (click)="removeOwnedImageFromAllowed(image)"
                        style="border-radius:50%;background: pink;top:-8px;right: -6px;border-radius:50%;background: pink;width: 24px;height: 24px;">
                        <mat-icon style="color:white">clear</mat-icon>
                    </div>
                </div>

                <div *ngFor="let item of compensateForPublished" class="place-img-wrap" droppable [dropScope]="'items'"
                    (onDragOver)="dragEnter($event)" (onDrop)="onItemDrop($event, 'allowed')"></div>
            </div>
            <h3 style="color: black">Upload Your Owned Images</h3>
            <h4 class="sub-image-title">
                Include your photography to replace or complement the Images. By uploading you confirm that your
                organization has the right to use and share these images.
            </h4>
            <div class="flex items-center">
                <ig-button class="btn-primary btn-upload-image" color="primary" size="md"
                    (trigger)="imageSelector.click()">
                    Upload New Image
                </ig-button>
                <ig-button class="btn-primary btn-upload-image m-l-3" color="primary" size="md"
                    (trigger)="enterImageLink()">
                    Enter Image Link
                </ig-button>
                <input type="file" class="invisible" multiple="multiple" accept="image/png,image/gif,image/jpeg"
                    #imageSelector (change)="onImageChange($event)">
            </div>
            <div class="flex gap-3 m-t-3" style="height:11vmin;margin-top: 20px; width:calc(100% - 10px)"
                (onDragOver)="dragEnter($event)" (onDrop)="onItemDrop($event, 'owned')">
                <div *ngFor="let image of ownedImages; let i = index"
                    class="place-img-wrap relative flex justify-center items-center" style="max-width:30%" draggable
                    [dragScope]="'items'" [dragData]="getImage(image.url)" (onDrag)="startDrag($event, 'owned')">
                    <img [src]="getImage(image.url)" alt="img" style="object-fit:cover">
                    <div class="absolute flex justify-center items-center gap-4" (click)="removeOwnImage(i)"
                        [matTooltip]="isWaitingForUpload(image.url) ? 'Remove' : 'Delete permanently'"
                        style="border-radius:50%;background: pink;top:0;right: -6px;border-radius:50%;background: pink;width: 24px;height: 24px;">
                        <mat-icon style="color:white">delete_forever</mat-icon>
                    </div>
                    <div *ngIf="image.status !== 'initial' && image.status !== 'done'"
                        class="absolute flex flex-col justify-center items-center gap-2"
                        style="width: 120px;height: 60px;color: white;background-color: #00000073;">
                        <mat-icon>{{
                            image.status === 'uploading' ? 'autorenew' : image.status === 'uploaded' ? 'check' :
                            'clear'
                            }}
                        </mat-icon>
                        <div class="flex gap-2">
                            <span>{{ image.status }}</span>
                            <span *ngIf="image.status==='failed'" class="link"
                                (click)="uploadOwnedImagesToAWS()">Retry</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="action-btns">
        <ig-button class="btn-primary" #confirmButton color="primary" size="md" [isAsync]="true"
            (trigger)="confirm($event)" [disabled]="!isPlaceInfoLoaded">
            Confirm
        </ig-button>
        <div class="cancel-btn" *ngIf="!confirmButton.isLoading" (click)="close()">
            Cancel
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.manually.place.images.modal/edit.manually.place.images.modal.component.html